import axios, { AxiosResponse } from 'axios'
import {
  AcoesModelo,
  AcoesProtocolo,
  ComparacaoProtocolo,
  ModeloPublicado,
  ModeloVersaoDetalhe,
  ModeloVersaoLinha,
  PreviaAprovacao,
  ProtocoloDetalhe,
  ProtocoloLinha,
} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const PROTOCOLOS_URL = `${API_URL}/protocolos-triagem`
const MODELO_URL = `${PROTOCOLOS_URL}/modelo-plataforma`

export const listarVersoes = (idEmpresa: number): Promise<ProtocoloLinha[]> =>
  axios
    .get(`${PROTOCOLOS_URL}/empresa/${idEmpresa}`)
    .then((res: AxiosResponse<ProtocoloLinha[]>) => res.data)

export const obterProtocolo = (id: number): Promise<ProtocoloDetalhe> =>
  axios.get(`${PROTOCOLOS_URL}/${id}`).then((res: AxiosResponse<ProtocoloDetalhe>) => res.data)

export const compararVersoes = (id: number, com?: number): Promise<ComparacaoProtocolo> =>
  axios
    .get(`${PROTOCOLOS_URL}/${id}/comparacao`, { params: com ? { com } : undefined })
    .then((res: AxiosResponse<ComparacaoProtocolo>) => res.data)

export const criarRascunho = (
  idEmpresa: number,
  idProtocoloOrigem: number
): Promise<ProtocoloDetalhe> =>
  axios
    .post(`${PROTOCOLOS_URL}/empresa/${idEmpresa}/rascunhos`, { idProtocoloOrigem })
    .then((res: AxiosResponse<ProtocoloDetalhe>) => res.data)

export const criarRascunhoDoModelo = (idEmpresa: number): Promise<ProtocoloDetalhe> =>
  axios
    .post(`${PROTOCOLOS_URL}/empresa/${idEmpresa}/rascunhos/modelo`)
    .then((res: AxiosResponse<ProtocoloDetalhe>) => res.data)

export const obterAcoes = (idEmpresa: number): Promise<AcoesProtocolo> =>
  axios
    .get(`${PROTOCOLOS_URL}/empresa/${idEmpresa}/acoes`)
    .then((res: AxiosResponse<AcoesProtocolo>) => res.data)

export const obterPreviaAprovacao = (id: number): Promise<PreviaAprovacao> =>
  axios
    .get(`${PROTOCOLOS_URL}/${id}/aprovacao/previa`)
    .then((res: AxiosResponse<PreviaAprovacao>) => res.data)

export const aprovarProtocolo = (id: number): Promise<ProtocoloDetalhe> =>
  axios
    .post(`${PROTOCOLOS_URL}/${id}/aprovar`)
    .then((res: AxiosResponse<ProtocoloDetalhe>) => res.data)

export const obterModeloPublicado = (): Promise<ModeloPublicado> =>
  axios.get(`${PROTOCOLOS_URL}/modelo`).then((res: AxiosResponse<ModeloPublicado>) => res.data)

// ------------------------------------------------------------------ modelo da plataforma

export const obterAcoesModelo = (): Promise<AcoesModelo> =>
  axios.get(`${MODELO_URL}/acoes`).then((res: AxiosResponse<AcoesModelo>) => res.data)

export const listarVersoesModelo = (): Promise<ModeloVersaoLinha[]> =>
  axios.get(`${MODELO_URL}/versoes`).then((res: AxiosResponse<ModeloVersaoLinha[]>) => res.data)

export const obterVersaoModelo = (id: number): Promise<ModeloVersaoDetalhe> =>
  axios
    .get(`${MODELO_URL}/versoes/${id}`)
    .then((res: AxiosResponse<ModeloVersaoDetalhe>) => res.data)

export const compararVersoesModelo = (id: number, com?: number): Promise<ComparacaoProtocolo> =>
  axios
    .get(`${MODELO_URL}/versoes/${id}/comparacao`, { params: com ? { com } : undefined })
    .then((res: AxiosResponse<ComparacaoProtocolo>) => res.data)

export const criarRascunhoModelo = (idVersaoOrigem?: number): Promise<ModeloVersaoDetalhe> =>
  axios
    .post(`${MODELO_URL}/versoes/rascunhos`, { idVersaoOrigem: idVersaoOrigem ?? null })
    .then((res: AxiosResponse<ModeloVersaoDetalhe>) => res.data)

export const publicarModelo = (id: number, hashBase: string): Promise<ModeloVersaoDetalhe> =>
  axios
    .post(`${MODELO_URL}/versoes/${id}/publicacao`, null, { params: { hashBase } })
    .then((res: AxiosResponse<ModeloVersaoDetalhe>) => res.data)
